/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { UniversalCandidateHitSchemaRecency } from './universalCandidateHitSchemaRecency';

export interface UniversalCandidateHitSchema {
  profile_id: string;
  full_name: string;
  headline?: string | null;
  avatar_url?: string | null;
  job_id: string;
  /** @maxLength 255 */
  job_title: string;
  project_id: string;
  recency?: UniversalCandidateHitSchemaRecency;
}
